import { toast } from "react-toastify";
import { useState } from "react";
import axiosInstance from "../../../../services/axios-client";

const useBottomRemark = () => {
    const [payload, setPayload] = useState(
        {
            ProjectID: '',
            EmployeeID: '',
            ProjectPhaseID: '',
            LowPerformance: '',
            Indisipliner: '',
            Attitude: '',
            WarningLetter: ''
        }
    )
    const [isSaving, setIsSaving] = useState(false)

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setPayload({ ...payload, [name]: value })
    }

    const getBottomRemark = async (projectID, employeeID, projectPhaseID) => {
        try {
            let res = await axiosInstance.get(`/auth/bottom-remark/${projectID}/${employeeID}/${projectPhaseID}`)
            if (res.status === 200) {
                if (res.data.data && res.data.data.ProjectID) {
                    setPayload(res.data.data)
                } else {
                    // Set IDs even if no data, so user can start filling the form
                    setPayload({
                        ProjectID: projectID,
                        EmployeeID: employeeID,
                        ProjectPhaseID: projectPhaseID,
                        LowPerformance: '',
                        Indisipliner: '',
                        Attitude: '',
                        WarningLetter: ''
                    })
                }
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const postBottomRemarks = async (projectID, employeeID, projectPhaseID, handleClose) => {
        try {
            setIsSaving(true)
            let sendPayload = { ...payload }
            sendPayload.ProjectID = projectID
            sendPayload.EmployeeID = employeeID
            sendPayload.ProjectPhaseID = projectPhaseID

            // Helper function to count letters (excluding spaces)
            const countLetters = (text) => {
                if (!text) return 0;
                return text.replace(/\s/g, '').length;
            };

            // Check if at least one field has minimum 20 characters
            const hasValidLowPerformance = countLetters(sendPayload.LowPerformance) >= 20;
            const hasValidIndisipliner = countLetters(sendPayload.Indisipliner) >= 20;
            const hasValidAttitude = countLetters(sendPayload.Attitude) >= 20;
            const hasValidWarningLetter = countLetters(sendPayload.WarningLetter) >= 20;

            const hasAtLeastOneValid = hasValidLowPerformance || hasValidIndisipliner || hasValidAttitude || hasValidWarningLetter;

            if (!hasAtLeastOneValid) {
                // Check if any field is filled but doesn't meet minimum
                if (sendPayload.LowPerformance && countLetters(sendPayload.LowPerformance) < 20) {
                    toast.error("Low Performance must be at least 20 characters (excluding spaces)")
                    return
                }
                if (sendPayload.Indisipliner && countLetters(sendPayload.Indisipliner) < 20) {
                    toast.error("Indisipliner must be at least 20 characters (excluding spaces)")
                    return
                }
                if (sendPayload.Attitude && countLetters(sendPayload.Attitude) < 20) {
                    toast.error("Attitude must be at least 20 characters (excluding spaces)")
                    return
                }
                if (sendPayload.WarningLetter && countLetters(sendPayload.WarningLetter) < 20) {
                    toast.error("Warning Letter must be at least 20 characters (excluding spaces)")
                    return
                }
                // If no field is filled at all
                toast.error("You should fill at least 1 justification with minimum 20 characters")
                return
            }

            // Validate filled fields that don't meet minimum requirement
            if (sendPayload.LowPerformance && countLetters(sendPayload.LowPerformance) < 20 && countLetters(sendPayload.LowPerformance) > 0) {
                toast.error("Low Performance must be at least 20 characters (excluding spaces) or leave it empty")
                return
            }
            if (sendPayload.Indisipliner && countLetters(sendPayload.Indisipliner) < 20 && countLetters(sendPayload.Indisipliner) > 0) {
                toast.error("Indisipliner must be at least 20 characters (excluding spaces) or leave it empty")
                return
            }
            if (sendPayload.Attitude && countLetters(sendPayload.Attitude) < 20 && countLetters(sendPayload.Attitude) > 0) {
                toast.error("Attitude must be at least 20 characters (excluding spaces) or leave it empty")
                return
            }
            if (sendPayload.WarningLetter && countLetters(sendPayload.WarningLetter) < 20 && countLetters(sendPayload.WarningLetter) > 0) {
                toast.error("Warning Letter must be at least 20 characters (excluding spaces) or leave it empty")
                return
            }

            let res = await axiosInstance.post(`/auth/bottom-remark`, sendPayload)
            if (res.status === 200) {
                toast.success("Successfully save justification")
                handleClose()
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }

    return {
        payload,
        setPayload,
        handleOnChange,
        getBottomRemark,
        postBottomRemarks,
        isSaving,
    }
}

export default useBottomRemark